<template>
  <div class="d-container">
    <div class="section_3 flex-row" v-if="!isPad" >
<!--      <img class="thumbnail_9" @click="goHistory" referrerpolicy="no-referrer"-->
<!--           src="../../assets/image/08.png" />-->
<!--      <span class="text_7">{{ navTitle}}</span>-->
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/homePage'">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">
          个人任务
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>

    <div class="substance">
      <div class="group_18 flex-row align-center">
        <span class="text_8">课文</span>
        <a-tree-select class="group_3" dropdownClassName="tree_drop_down" v-model="selCorpus"
                       :tree-data="treeData" tree-data-simple-mode allow-clear placeholder="请选择课文"
                       @select="selectCorpus">
          <template slot="title" slot-scope="item">
            <span :style="item.elementName === '1' ? 'color:#db5647': 'margin-left:20px'">
              {{ item.displayName }}
            </span>
          </template>
        </a-tree-select>
        <span class="text_10">班级</span>
        <a-select v-model="className" class="group_4" @change="changeClass" placeholder="请选择班级" allow-clear>
          <a-select-option :value="item.id" v-for="(item, index) in classData" :key="index">
            {{item.className}}
          </a-select-option>
        </a-select>
        <span class="text_12">状态</span>
        <a-select v-model="selTaskStatus" class="group_5" placeholder="请选择状态" allow-clear>
          <a-select-option :value="0"> 未提交 </a-select-option>
          <a-select-option :value="1"> 待批改 </a-select-option>
          <a-select-option :value="2"> 已打回 </a-select-option>
          <a-select-option :value="3"> 已批改 </a-select-option>
        </a-select>
      </div>
      <a-row class="table">
        <a-table class="ac-table" :columns="columns" :dataSource="tableList" :pagination="false"
                 :rowKey="(record,index)=>{return index}" :loading="loading" @change="changeTable">
          <span class="taskNameColor"  slot="taskContent" slot-scope="taskContent">
            {{ taskContent}}
          </span>
          <span :style="workStatus === 0?'color:red;':''" slot="workStatus" slot-scope="workStatus">
            {{ workStatus === 0 ? "未提交" : (workStatus === 1 ? "待批改" : (workStatus === 2 ? "已打回" : "已批改")) }}
          </span>
          <span slot="commitDate" slot-scope="commitDate">
            {{ commitDate === null ? '-': format.formatDayTime(commitDate) }}
          </span>
          <span slot="action" slot-scope="action, record">
            <span class="correctGo" v-if="action===1" @click="watchHomeWorkDetail(record)">
              去批改
            </span>
            <span disabled v-else-if="action===0" class="correctDis">
              去批改
            </span>
            <span class="btnCheck" v-else @click="watchHomeWorkDetail(record)">
              去查看
            </span>
          </span>
        </a-table>
        <div v-if="tableList.length!=0" style="text-align:center;margin-top:0.78125vw;">
          <a-config-provider>
            <a-pagination :page-size="pageSize" :current="pageNum" @change="changePageNum" :total='total' />
          </a-config-provider>
        </div>
      </a-row>
    </div>
  </div>
</template>

<script>
import { decryptDes } from 'utils/crypto.js';
import format from 'utils/format.js';

export default {
  name: 'NewPersonHomeWork',
  props: {
    // 任务类型
    taskType: {
      type: String,
      default: 'person',
    },
  },

  data() {
    return {
      loading: false,
      isPad: true,
      resBasePath: this.$resBasePath,
      bookId: '1', // 书籍列表默认为1
      classData: [], // 班级列表数据
      classId: '', // 班级ID
      styleId: '', // 课本样例ID
      styleName: '', // 课本样例ID
      lessonShow: false, // 课文弹窗展示
      noticyShow: false, // 消息提示
      bookLessonList: [], // 课文列表
      textSelect: '', // 选中的课文
      className: undefined, // 默认选中的班级
      columns: [], // 列表头
      pageNum: 1, // 默认页数
      total: 0,
      pageSize: 10,
      tableList: [], // 列表
      isRevise: '', // 批改状体
      isCommit: '', // 提交状态
      taskName: '', // 任务名称
      userName: '', // 批改人姓名
      redoList_zero: [], // 待处理的撤回请求
      redoList_one: [], // 已处理的撤回请求
      token: localStorage.getItem('access_token'),
      userId: '',
      selCorpus: null, // 所选课文id
      treeData: [],
      selTaskStatus: undefined, // 列表选择状态
      work_status: null, //  作业任务状态 0：未提交 1：待批改 2：已打回 3 已批改
      commitDateSort: -1, // 提交时间排序 0 升序 1 降序
      workStatusSort: -1, // 批改状态排序 0 升序 1 降序
      navTitle: '个人任务',
      format: format,
    };
  },
  mounted() {
    this.init();
    this.getClassNum();
    this.getBooks();
    this.getList();

    this.navTitle = this.taskType === 'group' ? '小组任务' : '个人任务';
    this.columns = [
      {
        title: '序号',
        dataIndex: 'sequenceId',
        align: 'center',
        width: 70,
      },
    ];

    if (this.taskType === 'group') {
      this.columns = this.columns.concat([
        {
          title: '小组名',
          dataIndex: 'groupName',
          align: 'center',
          scopedSlots: { customRender: 'groupName' },
        },
        {
          title: '小组长',
          dataIndex: 'userName',
          align: 'center',
          scopedSlots: { customRender: 'userName' },
        },
      ]);
    } else {
      this.columns.push({
        title: '姓名',
        dataIndex: 'userName',
        align: 'center',
        scopedSlots: { customRender: 'userName' },
        width: 150,
      });
    }

    this.columns = this.columns.concat([
      {
        title: '任务',
        dataIndex: 'taskContent',
        align: 'center',
        ellipsis: true,
        scopedSlots: { customRender: 'taskContent' },
      },
      {
        title: '提交时间',
        dataIndex: 'commitDate',
        align: 'center',
        sorter: true,
        scopedSlots: { customRender: 'commitDate' },
        width: 150,
      },
      {
        title: '批改状态',
        dataIndex: 'workStatus',
        align: 'center',
        sorter: true,
        scopedSlots: { customRender: 'workStatus' },
        width: 120,
      },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: { customRender: 'action' },
        width: 120,
      },
    ]);
  },
  methods: {
    init() {
      if (this.$route.path.indexOf('/accompanyStudy') === 0) {
        // 网页端
        this.isPad = false;
        this.userId = this.$getUserInfo().id;
      } else {
        // 手机端
        this.isPad = true;
        const parameter = decryptDes(this.$route.params.parameter);
        const params = parameter.split('&');
        console.log(parameter)
        this.token = params[0];
        this.userId = params[1];
        localStorage.setItem('access_token',params[0])
        console.log(this.token)
        console.log(this.userId)
        this.$win.addEventListener('resize', () => {
          this.setEditorHeight();
        });
      }
    },
    setEditorHeight() {
      const ele = this.$doc.querySelector('.w-e-text-container');
      const aele = this.$doc.querySelector('.tast-content');
      const h = this.isPad ? 70 : 250;
      ele.style.height = `${this.$win.innerHeight - aele.offsetHeight - h}px`;
    },
    getClassNum() {
      // 班级列表
      const _this = this;
      _this
        .$fetch({
          url: _this.$httpConfig.getTeaClassListByUserId,
          body: {
            token: this.token,
            userId: this.userId,
          },
        })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === '0') {
            _this.classData = res.resultData;
          }
        });
    },

    changeClass(e) {
      // 切换班级
      this.className = '';
      this.classId = '';
      this.pageNum = 1;
      const newData = this.classData.find((item) => {
        return item.id == e;
      });
      if (newData) {
        this.className = newData.className;
        sessionStorage.setItem('className', newData.className);
        sessionStorage.setItem('classId', e);
        this.classId = sessionStorage.getItem('classId');
      }
      this.getList();
    },
    getBooks() {
      // 获取书籍列表
      this.$fetch({
        url: this.$httpConfig.getBookStyleTierList,
        body: {
          token: this.token,
          userId: this.userId,
        },
      }).done((res) => {
        // console.log(res);
        if (res && res.success && res.resultData) {
          for (let i = 0; i < res.resultData.length; i++) {
            const element = res.resultData[i];
            const data = {
              id: 'b' + element.id,
              pId: -1,
              bookId: element.id,
              value: element.name,
              title: element.name,
              selectable: false,
              children: [],
            };
            if (element.children) {
              element.children.forEach((e1) => {
                data.children.push({
                  id: e1.id,
                  pId: data.id,
                  value: e1.id,
                  displayName: e1.name,
                  isLeaf: true,
                  elementName: '1',
                  selectable: false,
                  scopedSlots: {
                    title: 'title',
                  },
                });

                e1.children.forEach((ec1) => {
                  data.children.push({
                    id: ec1.id,
                    pId: data.id,
                    value: ec1.id,
                    displayName: ec1.name,
                    isLeaf: true,
                    elementName: '2',
                    selectable: true,
                    scopedSlots: {
                      title: 'title',
                    },
                  });
                });
              });
            }

            this.treeData.push(data);
          }
        }
      });
    },
    getList() {
      const param = {
        styleId: this.styleId,
        classId: this.classId,
        workStatus: this.work_status,
        commitDateSort: this.commitDateSort,
        workStatusSort: this.workStatusSort,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        userId: this.userId,
        token: this.token,
      };
      this.$fetch({
        url:
          this.taskType === 'group'
            ? this.$httpConfig.getTeaGroupTaskHomeWorks
            : this.$httpConfig.getTeaPersonTaskHomeWorks,
        body: param,
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          this.tableList = [];
          if (res && res.success && res.resultCode == 0) {
            this.total = res.resultData.total;
            if (res.resultData && res.resultData.list && res.resultData.list.length > 0) {
              let idx = 1 + (this.pageNum == null ? 0 : this.pageSize * (this.pageNum - 1));
              res.resultData.list.forEach((item) => {
                const ti = item;
                ti.sequenceId = idx++;
                ti.action = item.workStatus;
                this.tableList.push(ti);
              });
            }
          }
        });
    },
    watchHomeWorkDetail(record) {
      // console.log(record);
      // 查看作业详情
      const _this = this;
      _this.userName = record.userName;
      _this.taskName = record.taskName;
      let styleName = '';

      for (let i = 0; i < this.treeData.length; i++) {
        const td = this.treeData[i];
        const data = td.children.find((o) => o.id == record.styleId);
        if (data && data.displayName) {
          styleName = data.displayName;
          break;
        }
      }

      if (record.workStatus == 0) return;

      const obj1 = {
        classId: record.classId,
        className: record.className,
        groupName: record.groupName,
        styleId: record.styleId,
        styleName: styleName,
        taskId: record.taskId,
        taskName: _this.taskName,
        taskRecordId: record.id,
        teacherId: _this.userId,
        userId: record.userId,
        userName: record.userName,
        workStatus: record.workStatus,
      };
      if (!_this.isPad) {
        const rm = _this.taskType === 'group' ? 'GroupHomeWorkDetail' : 'PersonHomeWorkDetail';
        _this.$router.push({
          name: rm,
          params: obj1,
        });
      } else {
        const rp =
          (_this.taskType === 'group' ? '/groupHomeWorkDetail/' : '/personHomeWorkDetail/') +
          _this.$route.params.parameter;
        _this.$router.push({ path: rp });

        localStorage.setItem('obj', JSON.stringify(obj1));
      }
    },

    changePageNum(pageNum) {
      this.pageNum = pageNum;
      sessionStorage.setItem('homeWorkPageNumber', pageNum);
      this.getList();
    },

    goHistory() {
      // 返回
      this.$router.push({ name: 'AccompanyStudy' });
    },

    selectCorpus(value, node) {
      // console.log('s', value, node);
      this.styleName = node.dataRef.displayName;
    },

    changeTable(pagination, filters, sorter) {
      // console.log(sorter);
      this.commitDateSort = -1;
      this.workStatusSort = -1;
      if (sorter.order) {
        if (sorter.columnKey === 'commitDate') {
          this.commitDateSort = sorter.order === 'ascend' ? 0 : 1;
        } else if (sorter.columnKey === 'workStatus') {
          this.workStatusSort = sorter.order === 'ascend' ? 0 : 1;
        }
      }
      this.getList();
    },
  },

  watch: {
    selTaskStatus: function (nv, ov) {
      this.work_status = nv;
      this.pageNum = 1;
      this.getList();
    },

    selCorpus: function (nv, ov) {
      for (let i = 0; i < this.treeData.length; i++) {
        const td = this.treeData[i];
        const data = td.children.find((o) => o.id == nv);
        if (data && data.displayName) {
          this.styleName = data.displayName;
          break;
        }
      }

      this.pageNum = 1;
      this.styleId = nv;
      this.getList();
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'PersonHomeWorkDetail') {
      next((vm) => {
        vm.pageNum = sessionStorage.getItem('homeWorkPageNumber');
      });
    }
    next();
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/homework.less';

.catalog {
  // margin-top: 30px;
  width: 800px;
  height: 100%;
  border-radius: @border-radius-base;
  padding-left: 50px;
  // padding-top: 55px;
  padding-right: 50px;
  padding-bottom: 25px;
  position: relative;
  .resource {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 150px;
    z-index: 9;
    cursor: pointer;
  }
  .catalog-content-i {
    font-size: 20px;
    font-family: 'PingFangSC-Regular', 'Arial Narrow', Arial, sans-serif;
    color: #000000;
    line-height: 220%;
    position: relative;
  }
  .title {
    font-size: 24px;
    font-family: 'PingFangSC-Regular', 'Arial Narrow', Arial, sans-serif;
    color: #db5647;
    cursor: pointer;
  }
  .isClickable {
    cursor: pointer;
    &:hover {
      color: @primary-color;
    }
  }
  .disabled {
    color: @disabled-color;
  }
}
.recallBox {
  padding: 10px 20px;
  li {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #fff;
    margin: 8px 0px;
    display: flex;
    border-radius: 5px;
    .name {
      flex: 11;
      text-indent: 20px;
      color: #040506;
      font-size: 20px;
      .userImg {
        width: 30px;
        height: 30px;
        margin-top: -5px;
      }
      .userDetail {
        margin-left: 20px;
      }
      .userName {
      }
    }
    .lookHomeWork {
      flex: 7;
      cursor: pointer;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: @primary-color;
    }
    .argee {
      flex: 3;
      .ant-btn-primary {
        color: #fff;
        background-color: #22c190;
        border-color: #22c190;
      }
    }
    .disArgee {
      flex: 3;
      .ant-btn-danger {
        color: #fff;
        background-color: #db5647;
        border-color: #db5647;
      }
    }
    .agreeText {
      color: #22c190;
      margin-right: 20px;
    }
    .disArgeeText {
      color: #db5647;
      margin-right: 20px;
    }
  }
}
.solveMess {
  height: 600px;
  background: #f6f6f6;
  margin: 24px;
  /deep/.ant-modal-body {
    background-color: #f6f6f6;
  }
  /deep/.ant-modal-content {
    background-color: #f6f6f6;
    padding: 0px;
  }
}
/deep/.ant-table-pagination.ant-pagination {
  float: none;
}

.breadcrumb{
  margin: 20px auto 20px 40px;
  // width: 1200px;
}
</style>
